module.exports = __webpack_public_path__ + "media/images/logogrid-e989001afa3ead611fa9bdfd17bea2d1.gif";